import { BFormInvalidFeedback } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBFormInvalidFeedback = createEgBootstrapProxy(
  "EgBFormInvalidFeedback",
  BFormInvalidFeedback
);
